<template>
  <v-container class="my-12">
    <v-row align="center" justify="center">
      <v-col cols="12" md="6" class="text-left d-flex flex-column align-start">
        <h2 class="mb-6 text-h3 font-weight-thin">
          Workspace Tutorial
        </h2>

        <p>
          Here's what you'll learn in our tutorial:
        </p>
        <ul
          class="text-left mt-3"
          style="list-style-type: none; padding-left: 0;"
        >
          <li>
            <v-icon color="success" class="mr-2">mdi-check</v-icon>
            How to create and manage groups in your workspace
          </li>
          <li>
            <v-icon color="success" class="mr-2">mdi-check</v-icon>
            Inviting and managing team member access
          </li>
          <li>
            <v-icon color="success" class="mr-2">mdi-check</v-icon>
            Adding and organising groups within your workspace
          </li>
          <li>
            <v-icon color="success" class="mr-2">mdi-check</v-icon>
            Using filters to find and sort your groups
          </li>
        </ul>

        <v-btn class="mt-6" to="/teams/workspace" color="primary" rounded>
          Get Started
        </v-btn>
      </v-col>

      <v-col cols="12" md="6" class="d-flex justify-center align-center">
        <v-card
          class="video-preview-card"
          elevation="3"
          @click="dialog = !dialog"
        >
          <v-img
            src="/img/banner/linkbook_banner.jpg"
            height="225"
            cover
            class="video-image"
          >
            <template v-slot:default>
              <div class="video-overlay d-flex align-center justify-center">
                <v-icon size="64" color="white" class="play-button">
                  mdi-play-circle
                </v-icon>
              </div>
            </template>
          </v-img>
          <v-card-text class="text-center py-2">
            <span class="text-body-1">Click to watch the tutorial video</span>
          </v-card-text>
        </v-card>

        <v-dialog v-model="dialog" fullscreen class="video-dialog">
          <v-card class="video-dialog-card">
            <v-toolbar color="primary" dark class="video-toolbar flex-grow-0">
              <v-btn icon @click="dialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>Tutorial Video</v-toolbar-title>
            </v-toolbar>
            <div class="iframe-container">
              <iframe
                v-if="videoUrl"
                :src="videoUrl"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen
                class="full-height-iframe"
              ></iframe>
            </div>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'WorkspaceInstructions',
  data() {
    return {
      dialog: false,
      videoUrl:
        'https://youtu.be/djoV06MAL9k?si=__u96uiqQt_vZs4j&autoplay=1&vq=hd1080&modestbranding=1&rel=0&showinfo=0'
    }
  },
  watch: {
    dialog(newVal) {
      if (!newVal) {
        this.stopVideo()
      } else {
        this.startVideo()
      }
    }
  },
  methods: {
    stopVideo() {
      this.videoUrl = ''
    },
    startVideo() {
      this.videoUrl =
        'https://www.youtube.com/embed/djoV06MAL9k?si=gVY5KToATqUliD4Q&autoplay=1&vq=hd1080&modestbranding=1&rel=0&showinfo=0'
    }
  }
}
</script>

<style lang="scss" scoped>
.video-preview-card {
  cursor: pointer;
  transition: transform 0.2s ease-in-out;
  overflow: hidden;
  max-width: 450px;
  width: 100%;

  &:hover {
    transform: translateY(-4px);

    .play-button {
      transform: scale(1.1);
    }
  }
}

.video-image {
  position: relative;
  width: 100%;
}

.video-overlay {
  background: rgba(0, 0, 0, 0.3);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  transition: background 0.2s ease-in-out;

  &:hover {
    background: rgba(0, 0, 0, 0.5);
  }
}

.play-button {
  transition: transform 0.2s ease-in-out;
}

.video-dialog {
  z-index: 9999 !important;
}

.video-dialog-card {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
}

.video-toolbar {
  z-index: 10000 !important;
  position: relative;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.iframe-container {
  flex: 1;
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}

.full-height-iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
}

@media (max-width: 960px) {
  .video-preview-card {
    max-width: 100%;
  }
}

@media (max-width: 600px) {
  .video-preview-card {
    max-width: 320px;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
